var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" justify-content-around align-items-center px-5  pb-3 d-none d-lg-flex"})}
var staticRenderFns = []

export { render, staticRenderFns }